import script from "./CreatePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePassword.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePassword.vue?vue&type=style&index=0&id=56d71f0e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d71f0e"]])

export default __exports__